import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Audit() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/audit").then(({ data }) => setList(data)); }, []);
  return (
    <div className="p-8" data-testid="audit-page">
      <div className="mb-6">
        <div className="text-xs uppercase tracking-widest text-muted-foreground">Compliance</div>
        <h1 className="text-3xl font-display font-bold mt-1">Audit log</h1>
      </div>
      <div className="border border-border bg-white">
        <table className="dense-table w-full">
          <thead><tr><th>Timestamp</th><th>Azione</th><th>Entità</th><th>ID</th><th>Utente</th><th>Dettagli</th></tr></thead>
          <tbody>
            {list.map(e => (
              <tr key={e.id}>
                <td className="font-mono text-xs">{(e.timestamp||"").replace("T"," ").slice(0,19)}</td>
                <td className="uppercase text-[10px] tracking-widest">{e.action}</td>
                <td>{e.entity}</td>
                <td className="font-mono text-xs">{(e.entity_id||"").slice(-8)}</td>
                <td className="font-mono text-xs">{(e.user_id||"").slice(-8)}</td>
                <td className="font-mono text-[10px] max-w-md truncate">{JSON.stringify(e.details)}</td>
              </tr>
            ))}
            {list.length === 0 && <tr><td colSpan="6" className="text-center py-8 text-muted-foreground text-sm">Nessun evento.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
